import { DataConnectorTypesEnum } from '../../../api/externalData/enums/data-connector-types.enum';
import { DataConnectorApiModel } from '../../../api/externalData/models/data-connector-api.model';
import { GoogleAnalyticsAccountModel } from './google-analytics-account.model';

export class DataConnectorModel {
    id: number;
    name: string;
    type: DataConnectorTypesEnum;

    createdDate: Date;
    createdByUserId: number;
    lastModifiedDate: Date;
    lastModifiedByUserId: number;

    googleAnalyticsAccounts: GoogleAnalyticsAccountModel[];

    constructor(apiModel?: DataConnectorApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.name = apiModel.name;
            this.type = apiModel.type;

            this.createdDate = new Date(apiModel.createdDate);
            this.createdByUserId = apiModel.createdByUserId;
            this.lastModifiedDate = apiModel.lastModifiedDate ? new Date(apiModel.lastModifiedDate) : null;
            this.lastModifiedByUserId = apiModel.lastModifiedByUserId;
        }
    }

    toApi(): DataConnectorApiModel {
        return {
            id: this.id,
            name: this.name,
            type: this.type,

            createdDate: +this.createdDate,
            createdByUserId: this.createdByUserId,
            lastModifiedDate: +this.lastModifiedDate,
            lastModifiedByUserId: this.lastModifiedByUserId
        };
    }
}
